import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import EnergiaBlockLinked from './blocks/EnergiaBlockLinked.jsx';
import config from "../../devprodConfig";

export default function EnergiaKatselmusTab({ propertyId: propPropertyId }) {
  const location = useLocation();
  const [propertyId, setPropertyId] = useState(propPropertyId || null);
  const [tableId, setTableId] = useState(null);
  const [energiaData, setEnergiaData] = useState({
    blocks: [
      {
  title: "Lämmitysenergia",
  columns: [
    "Vuosi",
    "Mitattu kokonaiskulutus MWh",
    "Normeerattu kokonaiskulutus MWh",
    "Ominaiskulutus kWh/m³",
    "Ominaiskulutuksen vertailuarvo kWh/m³",
    "Erotus",
     
  ],
  rows: [],
  summary: "",
},
      {
        title: "Vesi",
        columns: [
          "Vuosi",
        "Mitattu kokonaiskulutus m³",
        "Ominaiskulutus l / hlö / vrk",
        "Ominaiskulutuksen vertailuarvo l / hlö / vrk",
        "Erotus",
         
        ],
        rows: [],
        summary: ""
      },
      {
        title: "Kiinteistösähkö",
        columns: [
          "Vuosi",
        "Mitattu kokonaiskulutus MWh",
        "Ominaiskulutus kWh/m³",
        "Ominaiskulutuksen vertailuarvo kWh/m³",
        "Erotus",
      
        ],
        rows: [],
        summary: "",
      },
    ],
  });

  const [loading, setLoading] = useState(true);

  // extract property id from URL if not provided
  useEffect(() => {
    if (!propPropertyId) {
      const match = location.pathname.match(/taloyhtiokortti\/(\d+)/);
      if (match) setPropertyId(match[1]);
    }
  }, [location.pathname, propPropertyId]);

  // load or create energia table
useEffect(() => {
  if (!propertyId) return;

  const load = async () => {
    try {
      const res = await fetch(
        `${config.apiBaseUrl}/api/energia_tables/by/id_kiinteisto/${propertyId}`,
        { credentials: "include" }
      );

      if (!res.ok) {
        console.error("Failed to fetch energia_tables:", res.status);
        return;
      }

      const rows = await res.json();

      if (Array.isArray(rows) && rows.length > 0) {
        const existing = rows[0];
        setTableId(existing.id);

        if (existing.data?.blocks) {
          setEnergiaData({
            ...existing.data,
            blocks: existing.data.blocks.filter(Boolean),
          });
        }
      } else {
        console.warn("⚠️ Energia table missing (should already exist)");
      }
    } catch (err) {
      console.error("Error loading energia_tables:", err);
    } finally {
      setLoading(false);
    }
  };

  load();
}, [propertyId]);

 const handleBlockSave = async (updatedBlock, idx) => {
  const updatedBlocks = energiaData.blocks.map((b, i) =>
    i === idx ? { ...b, ...updatedBlock, title: b.title } : b
  );

  const newData = { blocks: updatedBlocks };
  setEnergiaData(newData);

  if (!tableId) {
    console.error("❌ Missing tableId — table should already exist");
    return;
  }

  try {
    await fetch(`${config.apiBaseUrl}/api/energia_tables/${tableId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: newData }),
      credentials: "include",
    });

    console.log("✅ Energia table saved");
  } catch (err) {
    console.error("Energia table save failed:", err);
  }
};

if (loading) return <p>Ladataan energiadataa...</p>;


return (
  
  <div className="container-md py-3">
    {energiaData.blocks.map((block, idx) => (
      <div key={idx} className="card shadow-sm border-0 mb-4">
        
  {/* ✅ Header section inside the card */}
  <div
    className="card-header fw-bold text-uppercase"
    style={{
      backgroundColor: "#f8f9fa",
      color: "#000",
      fontSize: "1rem",
      borderBottom: "1px solid #ddd",
    }}
  >
    {block.title}
  </div>

  <div className="card-body px-4 py-3">
<EnergiaBlockLinked
  block={block}
  tableId={tableId}
  onSaveBlock={(updatedBlock) => handleBlockSave(updatedBlock, idx)}
/>



  </div>
</div>


    ))}
  </div>
);
}
